module.exports = __webpack_public_path__ + "static/bee_renewable_2-9313f999d7972e0c31c9410731c64398.jpg";